import React, {
    lazy, Suspense
} from 'react';
import ReactDom from 'react-dom';

import { LoadingView } from '@components';
// eslint-disable-next-line no-inline-comments
const AppMainEntry = lazy(() => import(
    /* webpackChunkName: "AppMainEntry" */
    './app-main-entry'
));

export default class EntryApp extends React.Component {
    constructor (element: string) {
        super({});
        if (!element) {
            const message = 'Element is undefined in entry-app renderElement()';

            console.error(message, element);
            throw new Error(message);
        }
        ReactDom.render(this.render(), window.document.querySelector(element));
    }

    render () {
        return (
            <Suspense fallback={<LoadingView />}>
                <AppMainEntry />
            </Suspense>
        );
    }
}

// This global is required in the index template
// @ts-ignore
window.EntryApp = EntryApp;
